
import { PropType, defineComponent, nextTick } from "vue";
import Communication from "@/model/Communication/Communication";
import { getCommunicationState } from "@/pinia/communications/CommunicationState";
import Database from "@/model/Database";
import * as Lang from "@/i18n/lang";
import Tag from "@/model/Tag";
import { getDatabaseManager } from "@/firebase/DatabaseManager";
import { getStoreManager } from "@/firebase/StoreManager";
import Store from "@/model/Store";
import EmployeeRole from "@/model/Employees/EmployeeRole";
import SeDropdownItem from "../global/dropdown/SeDropdownItem.vue";
import { CommunicationTargetType } from "@/components/communication/CommunicationTargetType";

export default defineComponent({
  expose: ["applyFilters", "displayFilters"],

  data() {
    return {
      CommunicationTargetType: CommunicationTargetType,
      Lang: Lang,
      state: getCommunicationState(),
      tags: [] as Tag[],
      stores: [] as Store[],
      targetType: CommunicationTargetType.everyone,
    };
  },

  async mounted() {
    this.tags = await getDatabaseManager().getStoreTags(this.database);
    this.stores = await getStoreManager().getStoresFromDatabase(this.database);
  },
  props: {
    database: {
      type: Database,
      required: true,
    },
  },
  methods: {
    displayFilters() {
      var refs = <any>this.$refs;

      if (this.state.communication!.target.stores.length > 0) {
        this.targetType = CommunicationTargetType.store;

        var stores = this.state.communication!.target.stores.map((x) =>
          this.stores.find((y) => y.ref.id == x.id)
        );

        nextTick(() => {
          refs.stores.setSelectedItems(stores);
        });
      } else if (this.state.communication!.target.store_tags.length > 0) {
        this.targetType = CommunicationTargetType.groups;

        var tags = this.state.communication!.target.store_tags.map((x) =>
          this.tags.find((y) => y.ref.id == x.id)
        );

        nextTick(() => {
          refs.tags.setSelectedItems(tags);
        });
      }
    },
    applyFilters() {
      var refs = <any>this.$refs;

      this.state.communication!.target.store_tags = [];
      this.state.communication!.target.stores = [];

      if (this.targetType == CommunicationTargetType.store) {
        var stores: Store[] = refs.stores.getSelectedItems();
        this.state.communication!.target.stores = stores.map((x) => x.ref!);
      }
      if (this.targetType == CommunicationTargetType.groups) {
        var tags: EmployeeRole[] = refs.tags.getSelectedItems();
        this.state.communication!.target.store_tags = tags.map((x) => x.ref!);
      }
    },
  },
});
